export const SETTINGS_PRICE_STEP = "settings-price"
export const SETTINGS_PRICE_DESCRIPTION = "Motorcycle Price and Terms"

export const DAILY_PRICE = "daily_price"
export const TERMS_SERVICE = "terms_service"
export const MULTIDAY_DISCOUNT = "multi_day_discounts"
export const SUBMIT_FOR_APPROVAL = "submited_for_review" 